// announcement hide body add class for menu drawer
document.addEventListener("DOMContentLoaded", function () {
  const announcement = document.querySelector('.announcement-marquee-bar');
  const body = document.body;

  if (announcement) {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) {
            // When announcement-bar is out of view
            body.classList.add('announcement-hidden');
          } else {
            // When announcement-bar is visible
            body.classList.remove('announcement-hidden');
          }
        });
      },
      {
        root: null, // viewport
        threshold: 0 // as soon as even 1px is not visible
      }
    );

    observer.observe(announcement);
  }
});


// Device height
function setDeviceHeight() {
  var deviceHeight = window.innerHeight;
  document.documentElement.style.setProperty('--device-height', deviceHeight + 'px');
}
document.addEventListener("DOMContentLoaded", function () {
  setDeviceHeight();
});
window.addEventListener('resize', function () {
  setDeviceHeight();
});


// announcement height
document.addEventListener("DOMContentLoaded", function () {
  getAnnouncementHeight();
});

function getAnnouncementHeight() {
  var anouncement = document.querySelector('div.shopify-section-group-header-group');
  if (anouncement) {
    var classAnnouncementHeight = anouncement.offsetHeight;
    document.documentElement.style.setProperty('--announcement-group', classAnnouncementHeight + 'px');
  }
}
window.addEventListener('resize', function () {
  getAnnouncementHeight();
});

// header height
document.addEventListener("DOMContentLoaded", function () {
  getHeaderHeight();
});

function getHeaderHeight() {
  var header = document.querySelector('header.header-section-new');
  console.log("header",header);
  if (header) {
    var classHeaderHeight = header.offsetHeight;
    document.documentElement.style.setProperty('--header-group', classHeaderHeight + 'px');
  }
 console.log("widhhh",window.innerWidth);
  if(window.innerWidth<1025){
    document.body.classList.add('notification-topbar-hide');
  }else{
    document.body.classList.remove('notification-topbar-hide');
  }
}

window.addEventListener('resize', function () {
  getHeaderHeight();
});

// drawer menu
document.addEventListener('DOMContentLoaded', function () {
    const menuToggle = document.querySelector('.menu-toggle');
    const menuDrawer = document.querySelector('.menu-drawer');
    const body = document.querySelector('body');

    menuToggle.addEventListener('click', function () {
      menuToggle.classList.toggle('is-open');
      menuDrawer.classList.toggle('is-open');
      body.classList.toggle('is-open');
    });
  });